export default __webpack_public_path__ + "static/media/plain-sticker-n.6bc41860.png";